import { render } from "./Index.vue?vue&type=template&id=55ea997c&bindings={\"courses\":\"props\",\"search_query\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "55ea997c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55ea997c')) {
    api.reload('55ea997c', script)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=55ea997c&bindings={\"courses\":\"props\",\"search_query\":\"props\",\"flash\":\"props\",\"selectedRecord\":\"data\",\"search\":\"options\",\"showDeleteConfirmationModal\":\"options\",\"deleteRecord\":\"options\",\"navigateToEdit\":\"options\"}", () => {
    api.rerender('55ea997c', render)
  })

}

script.__file = "resources/js/Pages/Courses/Index.vue"

export default script